import { runtime } from '../../../../classes/runtime/Runtime';
export class WordTaskInfo {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get wordTask() {
        return this.parent;
    }
    get onlyEvaluateOnManualSend() {
        return (
        /* OBSOLETE: this.wordTask.doesAlwaysRequireManualSend || */ this.wordTask.context.user &&
            this.wordTask.context.user.userStore.sendManually === 1);
    }
    get isCurrentlyHittingEnter() {
        return runtime.browserRuntime && runtime.browserRuntime.browserKeyboard.isKeyPressed('Enter');
    }
}
